import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import React from 'react';
import Button from '../../../buttons';
import colors from '../../../../themes/main-colors';
import { useTranslation } from '../../../../hooks/useTranslation';

import Icon from '../../../../static/green-future-choice.svg';
import { useStaticQuery, graphql } from 'gatsby';
import { getComponent } from '../../../../util/contentful-render-utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: `${theme.spacing(0, 20)} !important`,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        padding: `${theme.spacing(0, 1)} !important`,
      },
    },
    footer: {
      padding: theme.spacing(5, 0, 0, 0),
    },
    alignCenter: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: '15px',
      },
    },
    marginTop: {
      marginTop: theme.spacing(2),
    },
    root: {
      width: '100%',
      '& .MuiGrid-root': {
        backgroundColor: colors.white,
      },
      '& .spacingComponent  .Column div': {
        fontSize: '22px'
      },
      '& .MuiCardContent-root h2.MuiTypography-root': {
        lineHeight: '1.2rem'
      },
      '& .ContentfulElementColumns2 .spacingComponent': {
        padding: 0,
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(1.25, 0),
        },
      },

      '& .pge-contentful-body': {
        fontSize: '12px',
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(1.25, 0),
        },
      },
      '& .MuiTypography-h5': {
        fontSize: '16px',
        lineHeight: '0.5rem',
      },
      '& .MuiCardMedia-root': {
        width: '48px',
        height: '48px',
        margin: '0px 10px 8px 10px',
      },
    },
  }),
);

export interface GreenFutureChoiceProps {
  onClose: () => void;
  onSubmit: () => void;
  isEnrolled: boolean;
}

const greenFutureChoicePromoQuery = graphql`
  query greenFutureChoicePromoEntry {
    contentfulSecureSiteProgramPromo(
      contentful_id: { eq: "6tNjfo8P8eqoXSjdU3eQDl" }
    ) {
      __typename
      contentful_id
      hero {
        ...ModuleEmbedMediaWrapper
      }
      body {
        ...ModuleColumn3
      }
    }
  }
`;

const ProgramDetails = (props: GreenFutureChoiceProps) => {
  const { onClose, onSubmit, isEnrolled } = props;

  const classes = useStyles();
  const { t, richT } = useTranslation();

  const {
    contentfulSecureSiteProgramPromo: { body },
  } = useStaticQuery(greenFutureChoicePromoQuery);

  const cancel = () => {
    onClose();
  };
  
  return (
    <>
      <Grid item container className={classes.container}>
        <Typography variant={'h2'} className={classes.alignCenter}>
          <Icon style={{ width: '56px', height: '56px' }} />
          <span>{t('GREEN_FUTURE_CHOICE_TITLE_CASE')}</span>
        </Typography>
      </Grid>

      <Grid item container className={classes.container}>
        <Typography variant={'body1'} component={'div'}>
          {richT('SSM_GREEN_FUTURE_DETAILS_INFO')}
        </Typography>
      </Grid>

      <Grid item container className={classes.root}>
        <Grid item container className={classes.container}>
          {getComponent(body, 0)}
        </Grid>
      </Grid>
      {/* TODO: Adding habitat support has been removed as part of CUP-458. Will be implemented in futue scope. */}
      {/* <Grid item container className={classes.container}>
        <FormControlLabel
            control={
                <Checkbox
                    name={'habitatSupport'}
                    color={'primary'}
                    checked={false}
                />
            }
            label={<strong>{t('SSM_GREEN_FUTURE_ADD_HABITAT_SUPPORT')}</strong>}
        />
      </Grid> */}

      <Grid item container className={classes.container}>
        <Typography variant="inherit" component={'small'}>
          {t('SSM_GREEN_FUTURE_DISCLAIMER')}
        </Typography>
      </Grid>

      <Grid container justify="center">
        <Box className={classes.footer} mb={3}>
          <Button
            style={{ marginRight: 10 }}
            color={'secondary'}
            variant={'outlined'}
            onClick={() => cancel()}
          >
            {t('CANCEL')}
          </Button>
        <Button
            color={'secondary'}
            variant={'contained'}
            style={{ background: colors.orange }}
            onClick={onSubmit}
            data-testid="submit-button"
        >
            {isEnrolled ? t('UNENROLL') : t('ENROLL')}
        </Button>
        </Box>
      </Grid>
    </>
  );
};

export default ProgramDetails;
